module.exports = __webpack_public_path__ + "media/src/assets/Images/CarruselMobileRight-65f6c1023826f6e79c04f93caaa1c362.svg";